import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaYoutube, FaEnvelope, FaTwitter, FaInstagram, FaPaperPlane, FaCheckCircle } from "react-icons/fa";

const socialLinks = [
    { icon: FaYoutube, label: "YouTube", url: "https://www.youtube.com/@SportsDigitale" },
    { icon: FaTwitter, label: "X", url: "https://x.com/SportsDigitale" },
    { icon: FaInstagram, label: "Instagram", url: "https://www.instagram.com/sportsdigitale/" },
];

function ContactInfo() {
    return (
        <div>
            <h2 className="font-display text-2xl text-[var(--ink)] mb-4">İletişim Bilgileri</h2>
            <a
                href="mailto:info@sportsdigitale.com"
                className="inline-flex items-center gap-2 text-[var(--muted)] hover:text-[var(--accent)] transition-colors"
            >
                <FaEnvelope className="w-4 h-4" />
                info@sportsdigitale.com
            </a>

            <div className="mt-8">
                <h3 className="text-sm font-semibold uppercase tracking-wider text-[var(--muted)] mb-3">
                    Sosyal Medya
                </h3>
                <div className="flex items-center gap-4">
                    {socialLinks.map((social) => (
                        <a
                            key={social.label}
                            href={social.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={social.label}
                            className="text-[var(--ink)] hover:text-[var(--accent)] transition-colors"
                        >
                            <social.icon className="w-5 h-5" />
                        </a>
                    ))}
                </div>
            </div>

            <div className="mt-12 border border-[var(--line)] bg-[var(--surface)] p-8">
                <p className="font-display text-2xl md:text-3xl text-[var(--ink)] leading-snug">
                    Sporun dijital geleceğini birlikte şekillendirelim.
                </p>
                <p className="mt-4 text-sm text-[var(--muted)] leading-relaxed">
                    YouTube, Instagram ve X üzerinden Sports Digitale topluluğuna katılabilirsiniz.
                </p>
            </div>
        </div>
    );
}

function ContactForm() {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitted(true);
        setTimeout(() => setIsSubmitted(false), 3000);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div className="bg-[var(--surface)] border border-[var(--line)] p-6 md:p-8 h-full">
            <h3 className="font-display text-2xl text-[var(--ink)] mb-6 flex items-center gap-2">
                <FaPaperPlane className="w-4 h-4 text-[var(--accent)]" />
                Mesaj Gönder
            </h3>

            <AnimatePresence mode="wait">
                {isSubmitted ? (
                    <motion.div
                        key="success"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="text-center py-10"
                    >
                        <FaCheckCircle className="w-10 h-10 text-[var(--accent)] mx-auto mb-3" />
                        <h4 className="text-lg font-semibold text-[var(--ink)]">Mesajınız alındı</h4>
                        <p className="mt-1 text-sm text-[var(--muted)]">En kısa sürede dönüş yapacağız.</p>
                    </motion.div>
                ) : (
                    <motion.form
                        key="form"
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onSubmit={handleSubmit}
                        className="space-y-5"
                    >
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-[var(--ink)] mb-1.5">
                                Ad Soyad
                            </label>
                            <input
                                id="name"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2.5 bg-[var(--bg)] border border-[var(--line)] text-[var(--ink)] placeholder:text-[var(--muted)] focus:outline-none focus:border-[var(--accent)] transition-colors"
                                placeholder="Adınızı yazın"
                            />
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-[var(--ink)] mb-1.5">
                                E-posta
                            </label>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2.5 bg-[var(--bg)] border border-[var(--line)] text-[var(--ink)] placeholder:text-[var(--muted)] focus:outline-none focus:border-[var(--accent)] transition-colors"
                                placeholder="email@example.com"
                            />
                        </div>

                        <div>
                            <label htmlFor="message" className="block text-sm font-medium text-[var(--ink)] mb-1.5">
                                Mesaj
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="5"
                                className="w-full px-3 py-2.5 bg-[var(--bg)] border border-[var(--line)] text-[var(--ink)] placeholder:text-[var(--muted)] focus:outline-none focus:border-[var(--accent)] transition-colors resize-none"
                                placeholder="Mesajınızı yazın"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full py-3 bg-[var(--accent)] text-white font-semibold hover:opacity-90 transition-opacity inline-flex items-center justify-center gap-2"
                        >
                            <FaPaperPlane className="w-4 h-4" />
                            Gönder
                        </button>
                    </motion.form>
                )}
            </AnimatePresence>
        </div>
    );
}

export default function ContactPage() {
    return (
        <div className="min-h-screen bg-[var(--bg)]" style={{ paddingTop: 'var(--site-header-h, 3.5rem)' }}>
            <div className="w-11/12 max-w-5xl mx-auto py-16 md:py-20">
                <motion.header
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="mb-12 md:mb-16"
                >
                    <h1 className="font-display text-4xl md:text-6xl text-[var(--ink)]">İletişim</h1>
                    <p className="mt-3 text-[var(--muted)] max-w-xl leading-relaxed">
                        Geri bildirimleriniz ve iş birlikleri için bize yazın.
                    </p>
                </motion.header>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
                    <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1, duration: 0.45 }}
                    >
                        <ContactInfo />
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.45 }}
                    >
                        <ContactForm />
                    </motion.div>
                </div>
            </div>
        </div>
    );
}
